'use client';

import { useEffect } from 'react';

import { useDecisions } from '../../hooks';
import { createOrdergrooveLoaderLegacy } from './createOrdergrooveLoader.legacy';
import { createOrdergrooveLoaderV2 } from './createOrdergrooveLoader.v2';
import { getOgScriptUrl } from './utils';

type UseOrdergrooveMsiOptions = {
    onLoad: () => void;
    onError: () => void;
    isOgCookieSet: boolean;
};

export function useOrdergrooveMsi({ onLoad, onError, isOgCookieSet }: UseOrdergrooveMsiOptions) {
    const isOneTrust = useDecisions('onetrust');
    const scriptUrl = getOgScriptUrl();

    useEffect(() => {
        const loaderOptions = { onLoad, onError, isOgCookieSet, scriptUrl };

        if (isOneTrust) {
            return createOrdergrooveLoaderV2({ ...loaderOptions });
        }

        return createOrdergrooveLoaderLegacy(loaderOptions);
    }, [isOneTrust, onLoad, onError, isOgCookieSet, scriptUrl]);
}
